import Phaser from 'phaser';
import { t } from '@i18n/index';
import { PALETTE, TEXT_COLOUR, titleStyle, readoutStyle, FONT, px } from '../theme';
import { createButton } from '../ui/button';
import { GAME_VERSION } from '../version';

/**
 * Impressum und Hinweise im Spiel.
 *
 * Die vollstaendige Anbieterkennzeichnung steht in `public/impressum.html` —
 * sie muss auch ohne laufendes JavaScript erreichbar sein. Diese Szene traegt
 * das, was Spielende tatsaechlich interessiert: dass das Spiel mit KI gebaut
 * wurde, dass nichts nach Hause telefoniert, und woher die Kartendaten kommen.
 */
export class ImprintScene extends Phaser.Scene {
  constructor() {
    super('Imprint');
  }

  create(): void {
    this.cameras.main.setBackgroundColor(PALETTE.abyss);

    const { width, height } = this.scale;
    const centreX = width / 2;
    const columnWidth = Math.min(660, width - 100);
    const left = centreX - columnWidth / 2;

    this.add.text(left, 40, t('imprint.title'), titleStyle(22));
    this.add.text(left, 74, t('imprint.version', { version: GAME_VERSION }), {
      fontFamily: FONT.mono,
      fontSize: px(11),
      color: PALETTE.inkFaint,
    });

    let y = 112;
    for (const section of ['ai', 'privacy', 'data'] as const) {
      y = this.renderSection(left, y, columnWidth, section);
    }

    // Verweis auf die vollstaendige Seite — anklickbar, oeffnet einen neuen Tab.
    const link = this.add
      .text(left, y + 6, t('imprint.legal.hint'), {
        ...readoutStyle(11),
        color: TEXT_COLOUR.course,
      })
      .setInteractive({ useHandCursor: true });

    link.on('pointerdown', () => window.open('./impressum.html', '_blank', 'noopener'));

    createButton(this, centreX, height - 48, t('imprint.close'), () => this.scene.start('Menu'), {
      width: 180,
      height: 34,
      fontSize: 12,
    });

    this.cameras.main.fadeIn(280, 5, 8, 13);
  }

  /** Zeichnet einen Abschnitt und liefert die Höhe darunter zurück. */
  private renderSection(
    left: number,
    top: number,
    columnWidth: number,
    key: 'ai' | 'privacy' | 'data',
  ): number {
    this.add.text(left, top, t(`imprint.${key}.heading`), {
      fontFamily: FONT.mono,
      fontSize: px(11),
      color: TEXT_COLOUR.coast,
    });

    const body = this.add.text(left, top + 20, t(`imprint.${key}.body`), {
      ...readoutStyle(12),
      color: PALETTE.inkDim,
      wordWrap: { width: columnWidth },
      lineSpacing: 3,
    });

    return top + 20 + body.height + 26;
  }
}
